<template>
  <div class="wrapper">
    <side-bar>
      <template slot="links">
        <div class="text-center" v-if="loader">
          <div class="spinner-border" role="status">
            <span class="visually-hidden"></span>
          </div>
        </div>
        <sidebar-link to="/dashboard" name="Ballina" icon="ti-home" />
        <sidebar-link to="/profili" name="Profili" icon="ti-user" />
        <sidebar-link to="/planprogrami" name="Planprogrami" icon="ti-briefcase" />
        <sidebar-link to="/pagesat" name="Pagesat" icon="ti-money" />
        <sidebar-link to="/notat" name="Notat" icon="ti-pin2" />
        <!-- <sidebar-link to="/ParaqitjaProvimeve" name="Praqitja e provimeve" icon="ti-write" /> -->
        <sidebar-link to="/orariprovimeve" name="Orari i provimeve" icon="ti-time" />
        <sidebar-link to="/libraria" name="Libraria" icon="ti-book" />
        <sidebar-link to="/librariakolegjit" name="Libraria e Kolegjit" icon="ti-book" />
        <sidebar-link to="/njoftimet" name="Lajmërimet" icon="ti-bell" />
      </template>

      <mobile-menu>


        <drop-down class="nav-item" title="Njoftimet" title-classes="nav-link" icon="ti-bell">
          <a class="dropdown-item" v-for="item in njoftimet" target="_blank">
            <a :href=item.porosia target="_blank" style="white-space: break-spaces !important;">{{ item.titulli
            }}<br><small>{{ item.data }}</small></a>
          </a>
        </drop-down>
        <li class="nav-item">
          <a class="nav-link" v-on:click="Logout()">
            <i class="ti-user"></i>
            <p>Çkyqu</p>
          </a>
        </li>
        <li class="divider"></li>
      </mobile-menu>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar"> </dashboard-content>

      <content-footer></content-footer>

    </div>


  </div>
</template>
<style lang="scss"></style>
<script>

import moment from 'moment'
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
import { APISettings } from '../../api/config.js'

export default {
  data()
  {
    return {
      njoftimet: [],
      loader: false,
    }
  },

  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,

  },



  methods: {
    toggleSidebar()
    {
      if (this.$sidebar.showSidebar)
      {
        this.$sidebar.displaySidebar(false);
      }
    },

    gotoLogin()
    {
      if (this.$cookies.get("accesstoken") == null)
      {
        this.$router.push('/');
      }

    },

    getData1()
    {

      this.loader = true;
      var get_token = this.$cookies.get("accesstoken");
      fetch(APISettings.baseURL + `Njoftimet/getNjoftimetStudent/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + get_token
        },
      })
        .then(
          (signinResponse) =>
          {

            signinResponse.json().then((res) =>
            {
              if (signinResponse.status === 200)
              {
                this.loader = false;
                res.forEach((obj) =>
                {
                  const formattedDate = moment(obj.data).format('DD/MM/YYYY');
                  obj.data = formattedDate;
                  this.njoftimet = res;
                  if (this.njoftimet.length < 7)
                  {
                    this.njoftimet = res;
                  }
                  if (obj.titulli === undefined)
                  {
                    obj.titulli = "Kliko këtu"
                  }
                });
              } else if (signinResponse.status === 400)
              {
                console.log("ERROR DATA1");
              }
              this.loader = false;
            })
          }).catch(error =>
          {
            console.log("ERROR DATA2");
          })
    },
    Logout()
    {
      localStorage.setItem("user", "");
      var allCookies = document.cookie.split(';');

      for (var i = 0; i < allCookies.length; i++)
        document.cookie = allCookies[i] + "=;expires=" +
          new Date(0).toUTCString();
      this.$router.push('/');
    },


  },

  beforeMount()
  {
    this.gotoLogin();
    this.getData1();

  },


};
</script>

<style scoped></style>
